import moment from 'moment';
import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';

function getProfessionName(professions, profession) {
  if (!profession) {
    return 'Dental Hygienist';
  }
  return professions.filter((el) => el.code === profession).map((el) => el.name)[0];
}

function getProfessionCode(professions, professionType) {
  return professions.filter((el) => el.name === professionType).map((el) => el.code)[0];
}

const handleConfirmRemoveDate = (jobDates, deletedDate) => {
  const jobData = {};
  const datesFilteredArr = jobDates.filter((date) => date !== deletedDate);
  datesFilteredArr.forEach((date) => {
    jobData[date] = {};
  });
  return jobData;
};

const sortDates = (dates) => {
  const sortedDates = dates.map((date) => new Date(date)).sort((a, b) => a - b);
  return sortedDates.map((date) => date.toISOString().slice(0, 10));
};

const isDailyOvertime = (job, dailyOvertime) => {
  const { localStart, localEnd, is_break_paid, break_time } = job;
  const offerStartTime = moment(localStart, 'hh:mm A');
  const offerEndTime = moment(localEnd, 'hh:mm A');
  const hoursDifference =
    offerEndTime.diff(offerStartTime, 'hours', true) -
    (!is_break_paid ? convertTimeToMinutes(break_time) / 60 : 0);
  return hoursDifference > dailyOvertime;
};

const convertTimeToMinutes = (time) => {
  if (time.includes('min')) return parseInt(time, 10);

  if (time.includes('hr')) {
    const hours = parseFloat(time);
    return hours * 60;
  }

  return time;
};

const convertMinutesToFormattedValue = (minutes) => {
  if (minutes < 60) {
    return `${minutes} min`;
  }

  const hours = minutes / 60;
  return hours % 1 === 0 ? `${hours} hr` : `${hours.toFixed(1)} hr`;
};

const isWithinHoursLimit = (localDate, localStart, hoursLimit) => {
  const combinedDateTime = moment(`${localDate} ${localStart}`, 'YYYY-MM-DD hh:mm A');
  const currentTime = moment();
  const hoursDifference = combinedDateTime.diff(currentTime, 'hours');

  return hoursDifference <= hoursLimit;
};

const isUnlikelyShift = (startTime, endTime) => {
  const config = RemoteConfigUtils.getUnlikelyShiftConfiguration();

  if (!config) {
    return false;
  }

  // Extract only time portion (HH:mm) from the timestamps
  const start = startTime ? moment(startTime, 'hh:mm a').format('HH:mm') : null;
  const end = endTime ? moment(endTime, 'hh:mm a').format('HH:mm') : null;

  // Calculate duration in hours (using only time portion)
  let shiftDurationHours = null;
  if (end && start) {
    const startMoment = moment(start, 'HH:mm');
    const endMoment = moment(end, 'HH:mm');
    shiftDurationHours = endMoment.diff(startMoment, 'hours', true);
  }

  const { startBefore, startAfter, endBefore, endAfter, minShiftHours, maxShiftHours } = config;

  // Time comparisons (lexicographical string comparison works for HH:mm format)
  return (
    (start && start < startBefore) ||
    (start && start > startAfter) ||
    (end && end < endBefore) ||
    (end && end > endAfter) ||
    (shiftDurationHours !== null && shiftDurationHours < minShiftHours) ||
    (shiftDurationHours !== null && shiftDurationHours > maxShiftHours)
  );
};

export {
  getProfessionCode,
  getProfessionName,
  handleConfirmRemoveDate,
  isDailyOvertime,
  sortDates,
  convertTimeToMinutes,
  convertMinutesToFormattedValue,
  isWithinHoursLimit,
  isUnlikelyShift,
};
